import { Component, OnInit } from '@angular/core';
import { GuserService } from '../guser.service';
import { MenuComponent } from '../menu/menu.component';
import { AngularFirestore } from '@angular/fire/firestore';
import { Serial } from '../serial';
import { PayGuard } from '../pay.guard';
import { Router, ActivatedRoute } from '@angular/router';
import { User } from '../user';
import {IPayPalConfig,ICreateOrderRequest } from 'ngx-paypal';


@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.scss']
})
export class IndexComponent implements OnInit {

  usernameARR:User;
  checkSerials: any[] = [];
  serial:number;
  usuerId: any;
  paramsID:number;
  public payPalConfig ? : IPayPalConfig;

  constructor( private user:GuserService, private angularFS: AngularFirestore,
                    private pay:PayGuard, private activeRoute:ActivatedRoute,private router:Router) { }
  
  getUser() {
    new Promise(
      (resolve, reject) => {
        this.user.getCurrentUser().then(user => {
          if (user) {
            this.usernameARR = {displayName: user.displayName,email: user.email, uid:user.uid };
            this.showSerial()
          }
          else {
            this.usernameARR = null;
          }
        })
      }
    )
  }
  
  ngOnInit(): void {
    this.initConfig();
    this.activeRoute.params.subscribe(params => {
      this.paramsID = params.id;
    })
    this.getUser();
    this.pay.key=0;
  }
  private initConfig(): void {
    this.payPalConfig = {
        currency: 'USD',
        clientId: 'AVbt38jr4BtxbjljVhyjkoqcCuFxrmyvRtbxXgVDjukkOMBzds4oMTVh23m_lEuk4wzDZ7399mIWMb_g',
        createOrderOnClient: (data) => < ICreateOrderRequest > {
            intent: 'CAPTURE',
            purchase_units: [{
                amount: {
                    currency_code: 'USD',
                    value: '20',
                    breakdown: {
                        item_total: {
                            currency_code: 'USD',
                            value: '20'
                        }
                    }
                },
                items: [{
                    name: 'Enterprise Subscription',
                    quantity: '1',
                    category: 'DIGITAL_GOODS',
                    unit_amount: {
                        currency_code: 'USD',
                        value: '20',
                    },
                }]
            }]
        },
        advanced: {
            commit: 'true'
        },
        style: {
            label: 'paypal',
            layout: 'vertical'
        },
        onApprove: (data, actions) => {
            console.log('onApprove - transaction was approved, but not authorized', data, actions);
            actions.order.get().then(details => {
                console.log('onApprove - you can get full order details inside onApprove: ', details);
              this.pay.key = 1;
              this.router.navigate(['paydone']);
            });

        },
        onClientAuthorization: (data) => {
            console.log('onClientAuthorization - you should probably inform your server about completed transaction at this point', data);
            this.pay.key = 1;
            this.router.navigate(['paydone']);
        },
        onCancel: (data, actions) => {
            console.log('OnCancel', data, actions);
            this.router.navigate(['index']);

        },
        onError: err => {
            console.log('OnError', err);
            this.router.navigate(['index']);
        },
        onClick: (data, actions) => {
            console.log('onClick', data, actions);
           
        }
    };
}


 
  
  showSerial() {
    this.angularFS.collection<Serial>('users').doc(this.usernameARR.uid).valueChanges().subscribe(
      ser => {
       this.checkSerials.push(ser);
       this.checkSerials.forEach(element => {
          this.serial = element.Serial;
          
        });
      })
  }





  
  }

  

